<template>
  <div class="vx-card org-card">
    <!---->
    <div class="vx-card__collapsible-content vs-con-loading__container">
      <div
        class="flex-wrap p-6 pb-0 cursor-pointer"
        style="align-items: center"
        @click.stop="to()"
      >
        <div class="mb-3">
          <div v-if="boardTemplateInfo(boardData.boardId)">
            {{ boardTemplateInfo(boardData.boardId).title.toUpperCase() }}
          </div>
        </div>
        <div class="flex justify-between">
          <h3>{{ title }}</h3>
          <!-- <vx-tooltip
                text="Click to copy board invite link"
                position="bottom"
                style="display: flex; align-items: baseline"
                class="items-center"
                >
                <vs-button style="border-radius: 0px;" type="line" icon-pack="feather" icon="icon-link" @click="copyBoardInviteLink()"></vs-button>
            </vx-tooltip> -->
        </div>
      </div>
      <vs-divider />
      <div class="vx-card__body pt-3">
        <section v-if="metaData">
          <div>
            <div class="mb-base">
              <div class="bg-board-card-stat py-3 px-5 border-radius-6px">
                <div class="vx-row">
                  <div class="vx-col w-2/5 pl-0">
                    <div class="p-2 left-divider">
                      <!-- <h5 class="mb-3">
                                    Total
                                </h5> -->
                      <div>
                        <span class="stats-number">{{
                          metaData.totalBoardUsers
                        }}</span>
                      </div>
                      <small> Out of {{ boardData.numberOfUsers }} </small>
                    </div>
                  </div>
                  <div class="vx-col w-3/5">
                    <div class="p-2 left-divider">
                      <!-- <h5 class="mb-3">
                                    New
                                </h5> -->
                      <div class="flex justify-between">
                        <div>
                          <board-user-line-area-chart
                            v-if="metaData.newUserStat"
                            color="primary"
                            icon="UsersIcon"
                            statisticTitle="New Users"
                            :chartData="metaData.newUserStat.series"
                            type="area"
                          />
                        </div>
                        <div class="ml-4">
                          <div>
                            <span class="stats-number">{{
                              metaData.newBoardUsers
                                ? metaData.newBoardUsers.length
                                : 0
                            }}</span>
                          </div>
                          <small>New</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-between">
              <div>
                <!-- <vx-tooltip
                            text="Click to copy board invite link"
                            position="bottom"
                            style="display: flex; align-items: baseline"
                            class="items-center"
                            >
                            <vs-button style="border-radius: 0px;" type="line" icon-pack="feather" icon="icon-link" @click="copyBoardInviteLink()"></vs-button>
                      </vx-tooltip> -->
                <ul
                  v-if="last3BoardInvites.total > 0"
                  class="users-liked user-list"
                >
                  <li
                    v-for="(user, userIndex) in last3BoardInvites.data"
                    :key="userIndex"
                  >
                    <vx-tooltip
                      v-if="user && user.userData"
                      :text="`${user.userData.firstName} ${user.userData.lastName}`"
                      position="bottom"
                    >
                      <vs-avatar
                        v-if="user.userData.profilePictureUrl"
                        class="border-2 border-white border-solid -m-1"
                        size="32px"
                        :src="
                          constants.s3Bucket +
                          '/editor/profile-pictures/' +
                          user.userData.profilePictureUrl
                        "
                      />
                      <vs-avatar
                        v-else
                        size="32px"
                        class="border-2 border-white border-solid -m-1"
                        :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                          user.userData.firstName || 'boringAvatar',
                          user.userData.lastName || 'boringAvatar'
                        )}`"
                      />
                    </vx-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <div class="installed-apps">
                  <ul class="installed-apps-list ml-base">
                    <li
                      v-for="(appId, index) in boardData.installedApps"
                      :key="index"
                    >
                      <vx-tooltip
                        :text="
                          orgData.slug !== 'gala' && appId === 'coach'
                            ? 'Coach'
                            : getAppDataById(appId).title
                        "
                        position="bottom"
                      >
                        <div class="format-icon">
                          <img
                            width="32px"
                            :src="
                              require(`@/assets/images/icons/app-marketplace-colored/${appId}.svg`)
                            "
                          />
                        </div>
                      </vx-tooltip>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- <p v-else>Invite users to this<router-link :to="{name: 'org-boards-view', params: {boardId: boardData._id}}"> Board</router-link></p> -->
          <!-- <div v-else class="items-center">
            <img class="mb-3" src="@/assets/images/boards/start-onboarding.jpg" alt="Start On-Boarding" width="100%" style="opacity: 0.4;" />
            <vs-button :to="{name: 'org-boards-view', params: {boardId: boardData._id}}">Start On-Boarding</vs-button>
          </div> -->
        </section>
      </div>
      <!---->
    </div>
  </div>
</template>

<script>
import constants from "@/constants.js";
import boardTemplates from "@/assets/data/board-templates.js";
import _ from "lodash";
import marketplaceList from "@/assets/data/marketplace-list.js";
import BoardUserLineAreaChart from "./BoardUserLineAreaChart.vue";

export default {
  name: "Boardcard",
  components: {
    BoardUserLineAreaChart,
  },
  props: {
    title: { type: String },
    dataList: { type: Object },
    boardData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constants,
      last3BoardInvites: [],
      boardTemplates,
      marketplaceList,
      metaData: null,
      // subscribersGained: {
      //   series: [
      //     {
      //       name: 'New Users',
      //       data: [28, 40, 36, 52, 38]
      //     }
      //   ],
      //   analyticsData: {
      //     subscribers: 92600
      //   }
      // },
    };
  },
  watch: {
    boardData(newVal) {
      this.$store
        .dispatch("boards/fetchLast3BoardInvites", { boardId: newVal._id })
        .then((boardUsersRes) => {
          this.last3BoardInvites = boardUsersRes;
        })
        .catch((err) => {
          throw err;
        });

      // this.$store.dispatch('boards/fetchBoardMetaData', { boardId: newVal._id }).then(res => {
      //   this.metaData = res.data.metaData ? res.data.metaData : {};
      //   this.metaData['newUserStat'] = {};
      //   this.metaData['newUserStat']['series'] = [{
      //     name: 'New Users',
      //     data: []
      //   }];
      //   if(!_.isEmpty(this.metaData.boardUsersLastXDays) && this.metaData.boardUsersLastXDays.length > 1) {
      //     this.metaData['newUserStat']['series'][0]['data'] = _.map(this.metaData.boardUsersLastXDays, (bulxd) => { return bulxd.count});
      //   } else if(!_.isEmpty(this.metaData.boardUsersLastXDays) && this.metaData.boardUsersLastXDays.length === 1) {
      //     this.metaData['newUserStat']['series'][0]['data'] = [
      //       this.metaData.boardUsersLastXDays[0].count,
      //       this.metaData.boardUsersLastXDays[0].count,
      //       this.metaData.boardUsersLastXDays[0].count,
      //       this.metaData.boardUsersLastXDays[0].count,
      //       this.metaData.boardUsersLastXDays[0].count
      //     ]
      //   } else {
      //     this.metaData['newUserStat']['series'][0]['data'] = [0, 0, 0, 0, 0]
      //   }
      //   console.log(newVal.title, this.metaData);
      // }).catch(err => {
      //   throw err;
      // });
    },
  },
  computed: {
    // talentData() {
    //   return this.last3BoardInvites.data.slice(Math.max(this.last3BoardInvites.data.length - 3, 0)).reverse();
    // }
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },

    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  methods: {
    to() {
      this.$router.push({
        name: "org-boards-view",
        params: { boardId: this.boardData._id },
      });
    },
    boardTemplateInfo(boardTemplateId) {
      return _.find(this.boardTemplates, (bt) => {
        return bt.id == boardTemplateId;
      });
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    copyBoardInviteLink() {
      const boardInviteLink = `${constants.url}/board/invite/${this.boardData.slug}`;
      navigator.clipboard.writeText(boardInviteLink);
    },
  },
  mounted() {
    // console.log(this.boardData);
    if (this.boardData) {
      this.$store
        .dispatch("boards/fetchLast3BoardInvites", {
          boardId: this.boardData._id,
        })
        .then((boardUsersRes) => {
          this.last3BoardInvites = boardUsersRes;
        })
        .catch((err) => {
          throw err;
        });

      this.$store
        .dispatch("boards/fetchBoardMetaData", { boardId: this.boardData._id })
        .then((res) => {
          this.metaData = res.data.metaData ? res.data.metaData : {};
          this.metaData["newUserStat"] = {};
          this.metaData["newUserStat"]["series"] = [
            {
              name: "New Users",
              data: [],
            },
          ];
          if (
            !_.isEmpty(this.metaData.boardUsersLastXDays) &&
            this.metaData.boardUsersLastXDays.length > 1
          ) {
            this.metaData["newUserStat"]["series"][0]["data"] = _.map(
              this.metaData.boardUsersLastXDays,
              (bulxd) => {
                return bulxd.count;
              }
            );
          } else if (
            !_.isEmpty(this.metaData.boardUsersLastXDays) &&
            this.metaData.boardUsersLastXDays.length === 1
          ) {
            this.metaData["newUserStat"]["series"][0]["data"] = [
              this.metaData.boardUsersLastXDays[0].count,
              this.metaData.boardUsersLastXDays[0].count,
              this.metaData.boardUsersLastXDays[0].count,
              this.metaData.boardUsersLastXDays[0].count,
              this.metaData.boardUsersLastXDays[0].count,
            ];
          } else {
            this.metaData["newUserStat"]["series"][0]["data"] = [0, 0, 0, 0, 0];
          }
        })
        .catch((err) => {
          throw err;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.bg-board-card-stat {
  // background-color: rgba(var(--vs-primary), 0.3)!important;
  background: #ffffff !important; //#FAFAFD!important;
}

.left-divider {
  border-left: 2px solid #fafafd;
}
</style>

<style scoped>
.mkplace-icon >>> .vs-icon {
  font-size: 2rem !important;
}

.installed-apps {
  display: flex;
  justify-content: center;
  align-items: center;
}
.installed-apps-list {
  display: flex;
}
.installed-apps li {
  display: flex;
  filter: grayscale(100%);
}
.installed-apps li:hover {
  transform: translate(0px, -4px);
  z-index: 10;
  filter: grayscale(0);
}
.format-icon {
  margin-right: -8px;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
}
.stats-number {
  font-size: 25px;
  font-weight: bold;
  color: #30384b;
}
</style>
